import { inject, Pipe, PipeTransform } from '@angular/core';
import { AppdataService } from '../service/appdata.service';
import { IndustryType } from '../interfaces/responsedata.ts/datatypes';

@Pipe({
  name: 'getIndustryNameById',
  standalone: false
})
export class GetIndustryNameByIdPipe implements PipeTransform {

  dataService = inject(AppdataService);

  transform(value: string, lang: string = 'en'): string {
    let result = this.dataService.industryTypes.find(t => t.id === value);
    if (result) {
      return result[("name_" + lang) as keyof IndustryType];
    } else {
      return value;
    }
  }

}
